/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Plans_TitleInputs */

const da_terms_plans_title = /** @type {(inputs: Terms_Plans_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planer og priser`)
};

/** @type {(inputs: Terms_Plans_TitleInputs) => LocalizedString} */
const en_terms_plans_title = da_terms_plans_title;

/**

* @param {Terms_Plans_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const terms_plans_title = /** @type {((inputs?: Terms_Plans_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Plans_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_plans_title(inputs)
	return /** @type {LocalizedString} */ ("Planer og priser")
});